<template>
  <div class="vz-individual-order-cargo-hint">
    <span class="color-light text-caption">
      Грузовое место считается негабаритным:
      длина равна или превышает 4 м;
      вес более 500 кг и хотя бы одно из значений длины, ширины,
      высоты превышает 1.2×0.8×1.75 м соответственно
    </span>
  </div>
</template>
